module.exports = __webpack_public_path__ + "static/media/c.aac18dca.png";